import { render, staticRenderFns } from "./WidgetReviewsExternalMobile.vue?vue&type=template&id=564ca225"
import script from "./WidgetReviewsExternalMobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsExternalMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports